import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Natychmiastowy dostęp', 'Dożywotni dostęp', 'Wersja do druku', '30-dniowa gwarancja'];
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-116" data-mp="4lql31pohn65">
      <div className="mx-auto max-w-4xl text-center" data-id="element-117" data-mp="4na0kq3ifu6v">
        <motion.span initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.25,
        ease
      }} className="block text-[11px] font-bold uppercase tracking-[0.14em] text-brand sm:tracking-[0.18em]" data-id="element-118" data-mp="12a0mpfljy8wq">
          System materiałów z muzyki
        </motion.span>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease
      }} className="mt-2.5 font-display text-[2.5rem] font-black leading-[1.02] tracking-tight text-ink sm:text-6xl md:text-[4.2rem]" data-id="element-119" data-mp="nbeyhgxhkkxr">
          Przygotuj cały rok lekcji muzyki w zaledwie{' '}
          <span className="italic text-brand" data-id="element-120" data-mp="3o85a17s6zv2z">5 minut</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-121" data-mp="39acwgl67hgrf">
          10 tomów gotowych materiałów — od szkoły podstawowej po maturę. Koniec
          z szukaniem inspiracji i nut w niedzielny wieczór.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease
      }} className="mx-auto mt-2 max-w-3xl pb-5 pt-2.5 sm:mt-8" data-id="element-122" data-mp="2qkmsb7gjzimu">
          <img src="https://cdn.magicpatterns.com/uploads/ehL2Kxu9VmnvYKJa53dkQg/907b4867-ad30-4b97-ae5a-4ddbd8ff48ed.webp" alt="Pakiet Muzyka Gotowa: 10 tomów tematycznych od klasy 4 do matury, materiały cyfrowe na komputerze, tablecie i telefonie oraz 5 ekskluzywnych bonusów dla nowoczesnego nauczyciela" className="mx-auto w-full max-w-[16rem] sm:max-w-sm" data-id="element-123" data-mp="2hl9sl6i8e8fb" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.24,
        ease
      }} className="-mt-2 sm:mt-8" data-id="element-124" data-mp="ddf5agrlfybx">
          <CtaButton data-id="element-125" data-mp="161aznetoxe5j" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-126" data-mp="162uc0uc87521">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-127" data-mp="x1w7maxvkvix" data-mpi={index}>
                <span data-id="element-128" data-mp="3lsyun4p58wlp">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-129" data-mp="3lqm2xztl37vg">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}